import { Typography } from '@mui/material'
import * as S from './TransfersManagementPages.styles'
import { useHistory, useParams } from 'react-router-dom'
import { useEffect } from 'react'
import TransferPagesManagementTable from '../../components/TransferPagesManagementTable/TransferPagesManagementTable'

const TransfersManagementPages = () => {
  const { idList } = useParams<{ idList: string }>()

  const history = useHistory()

  const handleGoBack = () => {
    history.push('/transfers/manage')
  }

  useEffect(() => {
    if (!idList || Number.isNaN(Number(idList))) {
      handleGoBack()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idList])

  return (
    <S.Wrapper>
      <S.CustomButton
        title='Voltar'
        type='button'
        onClick={handleGoBack}
        bgColor='blue'
        hoverColor='darkBlueHover'
        letterColor='white'
        testId='go-back-button-test-id'
      />
      <Typography variant='h5' fontWeight='bold'>Gerenciamento de Páginas de Transferência</Typography>
      <TransferPagesManagementTable idList={Number(idList)} />
    </S.Wrapper>
  )
}

export default TransfersManagementPages
